import { FC } from "react";

import { ContentfulPicture, LogoBound, WithContext } from "../../../common/interfaces";
import { renderBrands } from "../../../common/utils";

import styles from './styles.module.scss';

const isLargeLaptop = window.innerWidth < 1720;
const isLaptop = window.innerWidth < 1480;
const isLaptopWithScaling = window.innerWidth < 1281;
const isMobile = window.innerWidth < 768;

const BOUNDS: LogoBound[] = [
    { height: isLaptopWithScaling ? 40 : isLaptop ? 44 : 60, maxWidth: 200, padding: 5 },
    { height: isLaptopWithScaling ? 50 : isLaptop ? 60 : 60, maxWidth: 200, padding: 5 },
    { height: isLaptopWithScaling ? 40 : isLaptop ? 50 : 60, maxWidth: 200, padding: 5 },
    { height: isLaptopWithScaling ? 50 : isLaptop ? 65 : 80, maxWidth: 200, padding: 5 },
    { height: isLaptopWithScaling ? 30 : isLaptop ? 39 : 40, maxWidth: 200, padding: 5 },
    { height: isLaptopWithScaling ? 40 : isLaptop ? 66 : isLargeLaptop ? 80 : 60, maxWidth: 200, padding: 5 },
    { height: isLaptopWithScaling ? 40 : isLaptop ? 40 : isLargeLaptop ? 50 : 53, maxWidth: 200, padding: 5 },
    { height: isMobile ? 34 : isLaptopWithScaling ? 40 : isLaptop ? 47 : isLargeLaptop ? 50 : 43, maxWidth: 200, padding: 5 },
    { height: isMobile ? 54 : isLaptop ? 30 : isLargeLaptop ? 30 : 70, maxWidth: isMobile ? undefined : isLaptop ? 200 : undefined, padding: 5 },
    { height: isMobile ? 21 : isLaptop ? 55 : isLargeLaptop ? 80 : 70, maxWidth: !isMobile ? 500 : undefined, padding: 5 },
]

const FIRST_LINE_OFFSET = 5;

const Partners: FC<WithContext> = ({ context }) => {
    const sectionData = context['Paragraph > Trusted installation partner for'];
    const logos: { pictures: ContentfulPicture[] }[] = sectionData?.pictures.filter((logo: any) => !!logo.pictures);

    return (
        <section className={styles.root}>
            <div className="row">
                <div className="col-md-12">
                    <h3>{sectionData?.headline}</h3>
                </div>
            </div>
            <div className="row">
                {logos && renderBrands(logos.map(({ pictures}) => pictures[0]), FIRST_LINE_OFFSET, BOUNDS, styles, true)}
            </div>
        </section>
    )
}

export default Partners;
